import { useState, useEffect } from 'react';

interface Settings {
  faviconUrl?: string;
  pageTitle?: string;
  iconUrl?: string;
  companyName?: string;
}

const GLOBAL_SETTINGS_KEY = 'app_global_settings_cache';

function readFromStorage(): Settings | null {
  try {
    const stored = localStorage.getItem(GLOBAL_SETTINGS_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function useGlobalSettings() {
  // Inicializa sincronamente do localStorage para evitar flash de favicon/título
  const [settings, setSettings] = useState<Settings | null>(readFromStorage());

  const loadSettings = async () => {
    try {
      const response = await fetch('/api/settings/public');

      if (response.ok) {
        const data = await response.json();
        const parsed: Settings = {
          faviconUrl: data.faviconUrl,
          pageTitle: data.pageTitle,
          iconUrl: data.iconUrl,
          companyName: data.companyName
        };
        try { localStorage.setItem(GLOBAL_SETTINGS_KEY, JSON.stringify(parsed)); } catch { /* ignore */ }
        setSettings(parsed);
      }
    } catch (err) {
      console.log('Não foi possível carregar configurações globais:', err);
    }
  };

  useEffect(() => {
    loadSettings();

    // Recarregar configurações a cada 30 segundos para detectar mudanças
    const interval = setInterval(loadSettings, 30000);

    return () => clearInterval(interval);
  }, []);

  return {
    settings,
    refetch: loadSettings
  };
}